import {ApiClientCommunication} from 'neo-common';

export class MaxPowerBonusSpinResponse extends ApiClientCommunication.ResponseBase {

    /**
     * @property Unique message ID generated by client.
     */
    messageId: number;

    /**
     * @property Status of mini-game. Can be one of: active, closed.
     */
    status: string;

    /**
     * @property Balance of the player.
     */
    balance: {
        /**
         * @property Real money balance.
         */
        real: number;

        /**
         * @property Bonus points balance.
         */
        bonus: number;
    };

    /**
     * @property Contains current state of game.
     */
    game: {
        /**
         * @property List of visible symbols (symbol IDs).
         */
        symbols: Array<number>;

        /**
         * @property Win from the mini-game. Sent only when mini-game is finished.
         */
        win: {
            /**
             * @property Code of winning bonus level.
             */
            level: string;

            /**
             * @property Win amount.
             */
            amount: number;
        };

        /**
         * @property Indicator whether win limit was reached.
         */
        limit: boolean;

    };

    /**
     * @property Initialization data. Sent only for Init request.
     */
    initData: {
        /**
         * @property ISO 4217 code for currency.
         */
        currency: string;

        /**
         * @property Denomination of 1 credit.
         */
        denomination: number;
    };

    protected internalValidate(errors: Array<string>): void {
    }
}


/** WEBPACK FOOTER **
 ** ./Engine/Communication/Game/Responses/MaxPowerBonusSpinResponse.ts
 **/